import io from 'socket.io-client';

// Устанавливаем подключение с настройками
const sockets = io('https://video-chat-web.ru', {
  autoConnect: false,  // Отключаем автоматическое подключение
  forceNew: true,      // Принудительно используем новое соединение
  transports: ['websocket'], // Используем только WebSocket для передачи данных
  withCredentials: true, // Включаем поддержку cookies/сессий, если это необходимо
});

// Обработчик ошибки подключения
sockets.on('connect_error', (err) => {
  console.error('Ошибка подключения:', err);
});

// Обработчик успешного подключения
sockets.on('connect', () => {
  console.log('Успешное подключение к серверу');
});

// Обработчик успешного отключения
sockets.on('disconnect', (reason) => {
  console.log('Отключено от сервера по причине:', reason);
});

// Принудительное подключение
sockets.connect();

// Пример отправки сообщения на сервер
const sendMessage = (roomId, msg, sender) => {
  sockets.emit('BE-send-message', { roomId, msg, sender });
};

// Пример приема сообщений от сервера
sockets.on('FE-receive-message', (data) => {
  console.log('Получено сообщение:', data);
});

// Пример отправки вызова (видеозвонка)
const makeCall = (userToCall, from, signal) => {
  sockets.emit('BE-call-user', { userToCall, from, signal });
};

// Пример принятия вызова
const acceptCall = (signal, to) => {
  sockets.emit('BE-accept-call', { signal, to });
};

// Пример выхода из комнаты
const leaveRoom = (roomId) => {
  sockets.emit('BE-leave-room', { roomId });
};

// Пример переключения камеры/микрофона
const toggleCameraAudio = (roomId, switchTarget) => {
  sockets.emit('BE-toggle-camera-audio', { roomId, switchTarget });
};

// Экспортируем сокет
export default sockets;
